// extracted by mini-css-extract-plugin
module.exports = {"container":"progress_container__2wwrF","progress":"progress_progress__3gbqG","text":"progress_text__3_wvf","primary":"progress_primary__HkDU7"};